<template>
  <v-card class="assignClient">

    <v-card-title>

      <v-layout class="assignClientHeader" row>
        <v-flex>
          <span class="roomName">ASSIGN CLIENT TO ROOM: {{ room.name }}</span>
        </v-flex>
      </v-layout>
      <v-spacer></v-spacer>
      <v-btn xs icon flat @click.stop="handleCancel()">
        <v-icon>close</v-icon>
      </v-btn>

    </v-card-title>

    <v-divider></v-divider>
    <v-card-text style="height: calc(90vh - 175px); overflow-y: auto;">

      <v-layout row>
        <v-flex>
          <div class="ntstValueLabel">Client ID</div>
          <v-text-field v-model="clientHumanReadableID" outline style="margin-right: 15px;"></v-text-field>
        </v-flex>
        <v-flex>
          <div class="ntstValueLabel">Client Last Name</div>
          <v-text-field v-model="clientLastName" outline style="margin-right: 15px;"></v-text-field>
        </v-flex>
        <v-flex>
          <div class="ntstValueLabel">Client First Name</div>
          <v-text-field v-model="clientFirstName" outline></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs4>
          <v-checkbox v-model="isSearchOnlyAllocated" label="Only Search Allocated?"></v-checkbox>
        </v-flex>
        <v-flex xs4>
          <v-checkbox :disabled="!isSearchOnlyAllocated" v-model="isSearchOnlyAllocatedForRoom" label="Only Search Allocated for this room?"></v-checkbox>
        </v-flex>
        <v-flex xs4 class="text-xs-right">
          <span>
            <v-btn class="ntstAppButton" @click.stop="handleSearch()">
              Search
            </v-btn>
            <v-btn class="ntstAppButton" @click.stop="handleClear()">
              Clear
            </v-btn>
          </span>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>
      <v-layout row child-flex>
        <v-data-table item-key="clientID.id" no-data-text="No Data..." :headers="headers" :items="searchResults" hide-actions class="elevation-1">
          <template slot="items" slot-scope="props">
            <tr @click="toggleSelectedRow(props.item)" :class="props.item.isSelected?'selectedRow':'unSelectedRow'">
              <td class="text-xs-right">{{ props.item.clientHumanReadableID }}</td>
              <td class="text-xs-left">{{ props.item.clientName }}</td>
              <td v-if="props.item.dob" class="text-xs-left">{{ props.item.dob|moment('MM/DD/YYYY') }}</td>
              <td v-else class="text-xs-left"></td>
              <td class="text-xs-left">{{ props.item.gender }}</td>
              <td v-if="props.item.admissionDate" class="text-xs-left">{{ props.item.admissionDate|moment('MM/DD/YYYY') }}</td>
              <td v-else class="text-xs-left"></td>
              <td class="text-xs-left">{{ props.item.dx }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-layout>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-layout col v-if="availableBeds">
        <span class="ntstValueLabel bedAssignmentLabel">Bed Assignment</span>
        <v-select class="bedSelector" v-model="selectedBedID" :items="availableBeds" item-value="bedBoardBedID.id" outline item-text="name"></v-select>
      </v-layout>

      <v-btn class="ntstAppButton" @click.stop="handleCancel()">
        Cancel
      </v-btn>

      <v-btn class="ntstAppButton" @click.stop="handleAssign()">
        Assign
      </v-btn>
    </v-card-actions>

    <v-dialog style="overflow-y:none;" v-if="isSearching" v-model="isSearching" persistent min-height="100px" width="210px">
      <div style="text-align:center; background-color: #fff; padding-bottom: 10px;">
        <busy-animation></busy-animation>
        <div class="ntstLoadingLabel">Searching...</div>
      </div>
    </v-dialog>

  </v-card>
</template>


<script>
import moment from 'moment';

import appSettings from '../appSettings';

import BusyAnimation from './BusyAnimation.vue';
import bedBoardUtils from '../bedBoardUtils';

export default {
  name: 'AssignClient',
  data() {
    return {
      clientFirstName: '',
      clientHumanReadableID: '',
      clientLastName: '',
      headers: [
        {
          text: 'Client ID',
          align: 'right',
          sortable: true,
          value: 'clientHumanReadableID'
        },
        {
          text: 'Client Name',
          align: 'left',
          sortable: true,
          value: 'clientName'
        },
        {
          text: 'DOB',
          align: 'left',
          sortable: true,
          value: 'dob'
        },
        {
          text: 'Gender',
          align: 'left',
          sortable: true,
          value: 'gender'
        },
        {
          text: 'Admission Date',
          align: 'left',
          sortable: true,
          value: 'admissionDate'
        },
        {
          text: 'Dx',
          align: 'left',
          sortable: true,
          value: 'dx'
        }
      ],
      isSearching: false,
      isSearchOnlyAllocated: false,
      isSearchOnlyAllocatedForRoom: false,
      pagination: {
        rowsPerPage: 5,
        totalItems: 0
      },

      searchResults: [],
      selectedBedID: null,
      selectedRowID: null
    };
  },

  props: {
    onAssign: Function,
    onCancel: Function,

    room: Object,
    unit: Object
  },

  components: {
    'busy-animation': BusyAnimation
  },

  computed: {
    availableBeds() {
      return this.$store.getters.getAvailableBeds(this.room.bedBoardRoomID);
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null
        || this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
    }
  },

  methods: {
    getClientName(name) {
      let returnValue = null;

      if (name) {
        returnValue = `${name.last}, ${name.first} ${
          name.middle ? name.middle[0] : ''
        }`.trim();
      }

      return returnValue;
    },
    getDate(date) {
      let returnValue = null;

      if (date) {
        returnValue = moment(date);
      }

      return returnValue;
    },
    handleAssign() {
      const selectedItem = this.searchResults.find(item => item.isSelected);
      if (selectedItem) {
        this.onAssign({
          alerts: null,
          bedID: this.selectedBedID ? { id: this.selectedBedID } : null,
          clientSummary: selectedItem.clientSummary,
          dischargeStatusCode: null,
          expectedDischargeDate: null,
          stayTypeCode: this.$store.getters.actionableStayTypeCodes[0]
        });
      } else {
        this.$dialog.alert('Please select client first.', {
          animation: 'fade',
          backdropClose: true
        });
      }
    },

    handleCancel() {
      this.onCancel();
    },
    handleClear() {
      this.clientFirstName = '';
      this.clientHumanReadableID = '';
      this.clientLastName = '';
      this.isSearchOnlyAllocated = false;
      this.isSearchOnlyAllocatedForRoom = false;
      this.searchResults = [];
    },
    handleSearch() {
      if (
        this.clientLastName
        || this.clientHumanReadableID
        || this.isSearchOnlyAllocated
      ) {
        this.isSearching = true;
        const params = {
          assigningToBedBoardRoomID: this.room.bedBoardRoomID,
          clientFirstName: this.clientFirstName,
          clientLastName: this.clientLastName,
          humanReadableClientID: this.clientHumanReadableID,
          isSearchAllocatedOnly: this.isSearchOnlyAllocated,
          isSearchAllocatedToRoomOnly: this.isSearchOnlyAllocatedForRoom,
          userName: this.$sdkAuth.getUserName('session')
        };
        this.searchResults = [];
        bedBoardUtils.executeSearchBedBoardClient(params)
          .then((responseData) => {
            this.isSearching = false;
            if (
              responseData
              && responseData.value
              && responseData.value.searchResults
              && responseData.value.searchResults.length > 0
            ) {
              responseData.value.searchResults.forEach((clientSummary) => {
                this.searchResults.push({
                  admissionDate: this.getDate(clientSummary.admissionDate),
                  clientID: clientSummary.clientID,
                  clientHumanReadableID:
                    clientSummary.clientID.humanReadableValue,
                  clientName: this.getClientName(clientSummary.clientName),
                  clientSummary,
                  dob: this.getDate(clientSummary.birthDate),
                  dx: clientSummary.PrimaryDxDescription,
                  gender: clientSummary.genderDescription,
                  isSelected: false
                });
              });
            }
            this.pagination.totalItems = this.searchResults.length;
          })
          .catch((err) => {
            this.isSearching = false;
            this.$log.error(`[${moment().format(appSettings.logDateFormat)}] ${err.message}`);
            this.$dialog.alert('Error selecting data.', {
              animation: 'fade',
              backdropClose: true
            });
          });
      } else {
        this.$dialog.alert(
          'Please enter client ID or last name OR check "Only Search Allocated".',
          {
            animation: 'fade',
            backdropClose: true
          }
        );
      }
    },
    toggleSelectedRow(item) {
      let isAlreadySelected = false;
      if (item) {
        isAlreadySelected = item.isSelected;
      }

      if (this.searchResults && this.searchResults.length > 0) {
        this.searchResults.forEach((result) => {
          result.isSelected = false;
        });
      }
      if (item) {
        item.isSelected = !isAlreadySelected;
      }
    }
  },

  created() {},

  mounted() {}
};
</script>

<style>
.bedSelector {
  max-width: 200px;
}
.bedAssignmentLabel {
  margin-right: 10px;
  vertical-align: m;
}
.selectedRow {
  background-color: #39b54a !important;
}
.roomName {
  color: #39b54a;
  font-size: 14px;
  font-weight: 700;
}
.unSelectedRow {
  background-color: #fff;
}
</style>
